var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1133 15.5529V7.77259C31.1133 6.05381 29.7199 4.66046 28.0011 4.66046H7.77229C6.0535 4.66046 4.66016 6.05381 4.66016 7.77259V29.5575C4.66016 31.2763 6.0535 32.6696 7.77229 32.6696H15.5526",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3859 23.3332H15.553",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 17.109H21.7771",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3857 11.0792H24.8892",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52315 23.5277C9.63057 23.5277 9.71766 23.4406 9.71766 23.3332C9.71766 23.2258 9.63057 23.1387 9.52315 23.1387C9.41573 23.1387 9.32864 23.2258 9.32864 23.3332C9.32864 23.4406 9.41573 23.5277 9.52315 23.5277",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52315 17.3035C9.63057 17.3035 9.71766 17.2164 9.71766 17.109C9.71766 17.0015 9.63057 16.9145 9.52315 16.9145C9.41573 16.9145 9.32864 17.0015 9.32864 17.109C9.32864 17.2164 9.41573 17.3035 9.52315 17.3035",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52315 11.2737C9.63057 11.2737 9.71766 11.1866 9.71766 11.0792C9.71766 10.9718 9.63057 10.8847 9.52315 10.8847C9.41573 10.8847 9.32864 10.9718 9.32864 11.0792C9.32864 11.1866 9.41573 11.2737 9.52315 11.2737",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2235 20.2211C31.0907 20.2211 34.2258 23.3561 34.2258 27.2234C34.2258 31.0906 31.0907 34.2257 27.2235 34.2257C23.3562 34.2257 20.2212 31.0906 20.2212 27.2234C20.2212 23.3561 23.3562 20.2211 27.2235 20.2211",
    stroke: "#0074B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6447 26.0143L26.6197 29.0393L24.8022 27.2234",
    stroke: "#0074B2",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.8c089b31592374c641a09d84d508e8b9.svg";
export { ForwardRef as ReactComponent };